module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/sysman/src/app/sysman/sysman.component.html
// module id = 1636
// module chunks = 2